import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import classes from "./WarrantyInformation.module.css";
import { Link } from "react-router-dom";

export default function WarrantyInformation() {
  return (
    <>
      <Helmet>
        <title>
          Warranty Information - Server Stock UK Delivery Methods and Timelines
        </title>
        <meta
          name="description"
          content="Explore Server Stock UK's Warranty Information. Learn about delivery times, cut-off schedules, DHL shipping, handling of missing or damaged items, and fast UK-wide delivery for IT products."
        />
        <link
          rel="canonical"
          href="https://www.serverstock.co.uk/warranty-information"
        />
      </Helmet>

      <Breadcrumb currentPage="Warranty Information" />
      <div className={`container ${classes.warrantyInformationContainer}`}>
        <h2 className={classes.mainHeading}>Warranty Policy</h2>
        <p className={classes.paragraph}>
          At Server Stock, our primary objective is to provide our valued
          customers with the most competitive prices for our products. We assure
          you that our prices will never surpass those of our competitors.
          Quality stands as our top priority, and we adhere to this principle
          rigorously. Prior to every shipment, we conduct a comprehensive
          quality assurance thorough proper inspection for all our products to
          ensure their authenticity at a 100% level. Our products are
          categorized as either "New Sealed" or "Used/Refurbished," and they are
          certified to meet high standards of quality.
        </p>
        <h3 className={classes.subheading}>100% Money Back Guarantee:</h3>
        <p className={classes.paragraph}>
          Carefully review our Return Policy for easy exchanges and returns.
        </p>
        <h3 className={classes.subheading}>Secure Payment & Shipment:</h3>
        <p className={classes.paragraph}>
          We deeply value the trust extended to us by our esteemed customers. To
          ensure your satisfaction, our team works diligently to deliver your
          products on time and securely, using our reliable payment system
        </p>
        <h3 className={classes.subheading}>
          Return Merchandise Authorization (RMA) Process:
        </h3>
        <p className={classes.paragraph}>
          When initiating the return of an item to Serverstock, it is requisite
          to initiate an RMA request subsequent to consenting to the established
          terms and conditions, the following conditions apply to all returns of
          Serverstock items, regardless of the reason for return:
        </p>
        <p className={classes.paragraph}>
          It is imperative that returned items include all accompanying
          accessories, manuals, software, and warranty claims, and further, they
          must be presented in their original packaging without any indication
          of damage.
        </p>
        <p className={classes.paragraph}>
          Upon receipt of your RMA number, it is essential to meticulously
          repack the merchandise in its original condition. Preferably, include
          an additional outer box outside of the original packaging. In the
          event of damage to the original packaging, a restocking fee of 50%
          will be assessed.
        </p>
        <p className={classes.paragraph}>
          To prevent the rejection of returns, refrain from writing directly on
          the original box or package. Instead, simply mention the RMA number
          clearly on the outer box.
        </p>{" "}
        <p className={classes.paragraph}>
          Precisely include Serverstock's complete and accurate address by
          affixing a label to the outer package.
        </p>
        <p className={classes.paragraph}>
          Upon receipt of the return shipment, our supply chain department will
          test and inspect the product. You can expect to receive your
          replacement product within ten days of receiving the damaged item.
        </p>
        <p className={classes.paragraph}>
          If there are any discrepancies between your purchase order (PO) and
          the received goods, please inform us within seven days of receiving
          the product.
        </p>
      </div>
    </>
  );
}
